<template>
  <footer
    v-show="isVisible"
    class="footer"
    :class="{ 'footer--overlay-visible': isLocaleOverlayVisible }"
  >
    <FooterIntro v-if="!isTabletOrDesktop" class="footer__intro" @navigation="trackNavigation" />
    <div class="footer__main">
      <div class="footer__main-inner">
        <div class="footer__top">
          <div class="footer__top-inner">
            <FooterNewsletter class="footer__newsletter" />
            <FooterLinks :isTabletOrDesktop="isTabletOrDesktop" @navigation="trackNavigation" />
          </div>
          <FooterSocial v-if="isDesktop" class="footer__social" />
          <FooterAdditionalLinks v-if="!isDesktop" @navigation="trackNavigation" />
        </div>
        <FooterBottom
          :isDesktop="isDesktop"
          @navigation="trackNavigation"
          @overlay-state-change="isLocaleOverlayVisible = $event"
        />
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import FooterAdditionalLinks from '@/components/Footer/FooterAdditionalLinks.vue'
import FooterBottom from '@/components/Footer/FooterBottom.vue'
import FooterIntro from '@/components/Footer/FooterIntro.vue'
import FooterLinks from '@/components/Footer/FooterLinks.vue'
import FooterNewsletter from '@/components/Footer/FooterNewsletter.vue'
import FooterSocial from '@/components/Footer/FooterSocial.vue'

export default {
  name: 'Footer',
  components: {
    FooterAdditionalLinks,
    FooterBottom,
    FooterIntro,
    FooterLinks,
    FooterNewsletter,
    FooterSocial,
  },

  props: { isVisible: { type: Boolean, default: true } },

  data() {
    return {
      isLocaleOverlayVisible: false,
    }
  },

  computed: {
    ...mapGetters({
      isMqMedium: 'viewport/isMqMedium',
      isMqLarger: 'viewport/isMqLarger',
    }),

    isDesktop() {
      return this.isMqLarger
    },

    isTabletOrDesktop() {
      return this.isMqMedium
    },
  },

  methods: {
    trackNavigation(element) {
      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.navigation,
        details: { action: 'footer', label: element.path },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import './footer-settings';

.footer {
  position: relative;
  z-index: 999;
  color: $c-white;
  font-family: $font-family-helvetica-now;

  &--overlay-visible {
    z-index: 1000;
  }

  &__intro {
    padding: 40px $container-padding-x-mobile;
  }

  &__main {
    padding: 40px $container-padding-x-mobile 80px;
    background-color: $c-black;

    @media ($mq-medium) {
      padding: 40px $container-padding-x 0;
    }
  }

  &__main-inner {
    max-width: 1500px;
    margin: 0 auto;
  }

  &__top {
    @media (min-width: $tablet-bp) {
      display: flex;
    }
  }

  &__top-inner {
    @media (min-width: $mobile-bp) {
      display: flex;
      flex: 1;
    }
  }

  &__newsletter {
    padding-bottom: 60px;
  }

  &__social {
    padding-top: 40px;

    @media (min-width: $mobile-bp) {
      padding-top: 24px;
    }

    @media (min-width: $tablet-bp) {
      padding-top: 7px;
    }
  }
}
</style>
